module.exports = __webpack_public_path__ + "static/media/cases_brand_riovermelho_01.52e9d043.jpg";